import { useTranslation } from 'react-i18next';
import AttrLabel from '../Components/AttrLabel';
import InlineLabel from '../Components/InlineLabel';
import PanelSection from '../Components/PanelSection';
import AttrField from '../Fields/AttrField';
import BorderFields from '../Fields/BorderFields';
import ColorInput from '../Fields/ColorField';
import HorizontalAlign from '../Fields/HorizontalAlign';
import PaddingFields from '../Fields/PaddingFields';
import PixelField from '../Fields/PixelField';
import FileField from '@SidePanel/Fields/FileField';

// TODO: Alt text, link and Alignment
function ImagePanel() {
    const { t } = useTranslation();

    return (
        <>
            <PanelSection label={t('Image Details')} defaultExpanded>
                <AttrField
                    name="src"
                    Component={FileField}
                    sx={{ height: 100 }}
                />
                {/* <AttrLabel>{t('Image URL')}</AttrLabel>
                <AttrField name="src" placeholder={t('Image URL')} /> */}
                <AttrLabel>{t('Alt Text')}</AttrLabel>
                <AttrField name="alt" placeholder={t('Describe the image')} />
                <AttrLabel>{t('Link')}</AttrLabel>
                <AttrField
                    dir="ltr"
                    name="href"
                    placeholder={'https://example.com'}
                    property="data"
                />
            </PanelSection>
            <PanelSection label={t('Size & Spacing')}>
                <InlineLabel label={t('Alignment')}>
                    <HorizontalAlign
                        property="containerAttributes"
                        name="style.justifyContent"
                    />
                </InlineLabel>
                <AttrLabel>{t('Width')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.width"
                    placeholder={t('Full Width')}
                    fallback="100%"
                />
                <AttrLabel>{t('Height')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.height"
                    placeholder={t('Auto')}
                />
                <AttrLabel>{t('Padding')}</AttrLabel>
                <PaddingFields
                    name="style.padding"
                    property="containerAttributes"
                />
            </PanelSection>
            <PanelSection label={t('Border')}>
                <BorderFields property="attributes.style" />
            </PanelSection>
            <PanelSection label={t('Block Styles')}>
                <AttrLabel>{t('Background Color')}</AttrLabel>
                <AttrField
                    Component={ColorInput}
                    name="style.backgroundColor"
                    placeholder={t('Transparent')}
                    property="containerAttributes"
                />
            </PanelSection>
        </>
    );
}

export default ImagePanel;
